import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AppShell } from '@1823-partners/core';
import Dashboard from './components/Dashboard';
import api from './api';

export default function App() {
  return (
    <AppShell appName="cre" title="CRE" api={api}>
      {({ userInfo }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Dashboard userId={userInfo?.userDetails} />
        </LocalizationProvider>
      )}
    </AppShell>
  );
}
